import { render, staticRenderFns } from "./OrgSubheader.vue?vue&type=template&id=bc9e6b08"
import script from "./OrgSubheader.vue?vue&type=script&lang=js"
export * from "./OrgSubheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports